import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useTheme, Box, IconButton, InputBase } from "@mui/material";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';
import { AppBar, Toolbar, Typography, Badge, Popover, List, ListItem, ListItemText, ListSubheader, ListItemButton, ListItemAvatar, Divider, Avatar } from '@mui/material'
import { useProSidebar } from "react-pro-sidebar";
import { cerrarSesion } from "../../Redux/usuarios";
import { UserAuth } from "../../context/AuthContext";
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import logo from '../../img/EducativaBlanco.png'
import logoNegro from '../../img/EducativaNEgro.png'
import logoBlanco from '../../img/logo_blanco.png'
import logoColor from '../../img/logo_color.png'
import FlexBetween from "../FlexBetween";
import { LightModeOutlined, DarkModeOutlined, Menu as MenuIcon, Search, ArrowDropDownOutlined } from '@mui/icons-material'
import { misMensajes } from "../../Redux/mensajes";
import { useDispatch, useSelector } from 'react-redux'
import TokenContext from "../../context/TokenContext";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const Topbar = ({ cambiarColor }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const { toggleSidebar, broken, rtl } = useProSidebar();
    const { user, logout } = UserAuth()
    const { empleado } = UserAuth()
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [mensajes, setMensajes] = React.useState([])
    const [loading, setLoading] = React.useState([])
    const loadingMensajesSelector = useSelector(store => store.mensajes.loadingMensajes)
    const mensajesSelector = useSelector(store => store.mensajes.mensajes)


    const [notificacionesAbiertas, setNotificacionesAbiertas] = React.useState(false);

    React.useEffect(() => {
        if (token && empleado) {
            dispatch(misMensajes(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado])

    React.useEffect(() => {
        setLoading(loadingMensajesSelector)
    }, [loadingMensajesSelector])

    React.useEffect(() => {
        if (mensajesSelector.length > 0) {
            var array = []
            mensajesSelector.forEach(item => {
                var object = {
                    id: item.activityid,
                    title: item.subject,
                    description: item.description,
                    statuscode: item["statuscode@OData.Community.Display.V1.FormattedValue"],
                    type: item["new_tipodenotificacion@OData.Community.Display.V1.FormattedValue"],
                    createdAt: item["createdon@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(object)
            })
            setMensajes(array)
        }
    }, [mensajesSelector])

    React.useEffect(() => {
        // Verificar si las notificaciones están abiertas en el localStorage
        const notifAbiertasStorage = localStorage.getItem('notificacionesAbiertas');
        setNotificacionesAbiertas(notifAbiertasStorage === 'true');
    }, []);


    const handleOpenNotifications = event => {
        setAnchorEl(event.currentTarget);

        setNotificacionesAbiertas(true);
        localStorage.setItem('notificacionesAbiertas', 'true');
    };

    const handleCloseNotifications = () => {
        setAnchorEl(null);
    };

    const handleLogout = async (e) => {
        e.preventDefault()
        try {
            await logout()
            dispatch(cerrarSesion())
            navigate('/')
            console.log("cerraste la sesion")
        } catch (error) {
            console.log(error.message)
        }
    }

    // Esto es basicamente el list personalizado de notificaciones
    const NotificationItem = ({ notification }) => {
        const { avatar, title } = renderContent(notification);

        return (
            <ListItemButton
                sx={{
                    py: 1.5,
                    px: 2.5,
                    mt: '1px',
                    ...(notification.isUnRead && {
                        bgcolor: 'action.selected',
                    }),
                }}
            >
                {/* Esto es un avatar para cada notificacion, segun el tipo de notificacion
                <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'background.neutral' }}>{avatar}</Avatar>
                </ListItemAvatar> */}
                <ListItemText
                    primary={title}
                    secondary={
                        <Typography
                            variant="caption"
                            sx={{
                                mt: 0.5,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.disabled',
                            }}
                        >
                            <AccessTimeIcon sx={{ mr: 0.5, width: 16, height: 16 }} />
                            {notification.createdAt}
                        </Typography>
                    }
                />
            </ListItemButton>
        );
    }
    // Esto es lo que va a renderizar finalmente
    const renderContent = (notification) => {
        const title = (
            <Typography variant="subtitle2">
                {notification.title}
                <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
                    &nbsp; {notification.description}
                </Typography>
            </Typography>
        );
        //aca hago la condicion por cada tipo de notificacion mostrar un diferente avatar   
        // if (notification.type === 'Encuestas') {
        //     return {
        //         avatar: <img alt={notification.title} src="/img/icons/EncuestaIcon.svg" />,
        //         title,
        //     };
        // }
        return {
            avatar: notification.avatar ? <img alt={notification.title} src={notification.avatar} /> : null,
            title,
        };
    }

    return (
        <AppBar
            sx={{
                position: "static",
                background: "transparent",
                boxShadow: "none",
                bgColor: "#fff"
            }}
        >
            <Toolbar sx={{ justifyContent: "space-between" }}>
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    flexDirection: 'row',
                    display: { xs: 'none', sm: 'block' }
                }}>
                    {
                        theme.palette.mode == 'dark' ?
                            <img src={logoBlanco} alt="Logo Responsive" style={{ height: "5rem" }} /> :
                            <img src={logoColor} alt="Logo Responsive" style={{ height: "5rem" }} />
                    }
                </Box>
                {/* Lado izquierdo */}
                <FlexBetween>
                    <Box display="flex">
                        {broken && !rtl && (
                            <IconButton
                                sx={{ margin: "0 6 0 2" }}
                                onClick={() => toggleSidebar()}
                            >
                                <MenuOutlinedIcon />
                            </IconButton>
                        )}
                    </Box>
                </FlexBetween>
                {/* Lado derecho */}
                <FlexBetween gap="0.2rem">
                    <>
                        <Tooltip title={<Typography sx={{ color: '#fff' }}>Notificaciones</Typography>}>

                            <IconButton variant="contained" onClick={handleOpenNotifications}>
                                {theme.palette.mode === 'dark' ?
                                    (
                                        <Badge
                                            badgeContent={notificacionesAbiertas ? null : mensajes.length}
                                            color="error"
                                        >
                                            <NotificationsNoneOutlinedIcon
                                                sx={{ fontSize: "25px", color: '#fff' }} />
                                        </Badge>

                                    )
                                    :
                                    (
                                        <Badge
                                            badgeContent={notificacionesAbiertas ? null : mensajes.length}
                                            color="error" >
                                            <NotificationsNoneOutlinedIcon sx={{ fontSize: "25px", color: '#000' }} />
                                        </Badge>
                                    )
                                }
                            </IconButton>
                        </Tooltip>

                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleCloseNotifications}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    mt: 1.5,
                                    ml: 0.75,
                                    width: 360,
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                                    borderRadius: '8px',
                                },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="subtitle1">Notificaciones</Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        Tienes {mensajes.length} notificaciones pendientes
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider sx={{ borderStyle: 'dashed' }} />
                            <List
                                disablePadding
                                subheader={
                                    <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                                        {notificacionesAbiertas ? null : 'Nuevas'}
                                    </ListSubheader>
                                }
                            >
                                {mensajes.map((notification) => (
                                    <NotificationItem key={notification.id} notification={notification} />
                                ))}
                            </List>
                        </Popover>
                    </>

                    <Tooltip title={<Typography sx={{ color: '#fff' }}>Tema</Typography>}>
                        <IconButton onClick={cambiarColor}>
                            {theme.palette.mode === 'dark' ?
                                (
                                    <DarkModeOutlined sx={{ fontSize: "25px", color: '#fff' }} />
                                )
                                :
                                (
                                    <LightModeOutlined sx={{ fontSize: "25px", color: '#FFC107' }} />
                                )
                            }
                        </IconButton>
                    </Tooltip>
                    <FlexBetween>
                        <Tooltip title={<Typography sx={{ color: '#fff' }}>Cerrar Sesión</Typography>}>
                            <IconButton onClick={e => handleLogout(e)}>
                                {theme.palette.mode === 'dark' ?
                                    (

                                        <LogoutIcon
                                            sx={{ fontSize: "25px", color: '#fff' }} />

                                    )
                                    :
                                    (

                                        <LogoutIcon sx={{ fontSize: "25px", color: '#000' }} />

                                    )
                                }
                                {/* <LogoutIcon sx={{ fontSize: '25px', color: '#000' }} /> */}
                            </IconButton>
                        </Tooltip>
                    </FlexBetween>
                </FlexBetween>
            </Toolbar >
        </AppBar >
    );
};

export default Topbar;
